module.exports = __webpack_public_path__ + "static/media/winter-2.14dc5181.jpg";